module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "content-wrap"
  }, [_c('div', {
    staticClass: "container-fluid page-section clearfix",
    attrs: {
      "id": "section-portfolio"
    }
  }, [_c('h1', {
    staticClass: "bottommargin"
  }, [_vm._v("Portfolio")]), _vm._v(" "), _c('div', {
    staticClass: "portfolio grid-container portfolio-nomargin portfolio-full portfolio-3 portfolio-masonry mixed-masonry clearfix",
    attrs: {
      "id": "portfolio"
    }
  }, _vm._l((_vm.item_collection), function(item) {
    return _c('article', {
      staticClass: "portfolio-item pf-media pf-icons wide"
    }, [_c('div', {
      staticClass: "portfolio-image imagescale"
    }, [_c('router-link', {
      attrs: {
        "to": item.url
      }
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail,
        "alt": item.title
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "i-overlay on-hover",
      staticStyle: {
        "background": "rgba(255,255,255,0.7)"
      }
    }, [_c('router-link', {
      attrs: {
        "to": item.url
      }
    }, [_c('i', {
      staticClass: "icon-line-plus"
    })])], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "portfolio-desc"
    }, [_c('h3', [_c('router-link', {
      attrs: {
        "to": item.url
      }
    }, [_vm._v(_vm._s(item.title))])], 1), _vm._v(" "), _vm._l((item.tags), function(tag) {
      return _c('span', {
        staticClass: "item"
      }, [_vm._v("\n                " + _vm._s(tag) + "\n              ")])
    })], 2)])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d7db970"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/portfolio.vue
// module id = 105
// module chunks = 1